export enum PageBillingActionTypes {
  UPDATED_SUCCESS = 'page-billing/UPDATED_SUCCESS',
  UPDATED_ERROR = 'page-billing/UPDATED_ERROR',
  UPDATED_REQUEST = 'page-billing/UPDATED_REQUEST',
}
